import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, FormsModule, Validators}        from '@angular/forms';
import { ApiService } from '../api.service';
import { forbiddenEmailValidator } from '../em.validator';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.sass']
})
export class ContactComponent implements OnInit {
  owner = 'Levi Appenfelder'
  name = ''
  contactForm: FormGroup
  submitted = ''
  savedMessage = {}

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.contactForm = new FormGroup({
      'from_shopper': new FormControl('', [Validators.required]),
      'title': new FormControl('', [Validators.required]),
      'message': new FormControl('', [Validators.required]),
      'email': new FormControl(null, [Validators.required, forbiddenEmailValidator]),
    });
  }

  submitContact(val) {
    val.preventDefault()
    this.submitted = 'loading'

    this.savedMessage['admin'] = ["f6006a3ac4e9", "excessmaterial.official@gmail.com"]
    this.savedMessage['to_seller'] = "f6006a3ac4e9"
    this.savedMessage['from_shopper'] = this.contactForm.get('from_shopper').value
    this.savedMessage['title'] = this.contactForm.get('title').value
    this.savedMessage['message'] = this.contactForm.get('message').value
    this.savedMessage['email'] = this.contactForm.get('email').value
    this.savedMessage['selleremail'] = "excessmaterial.official@gmail.com"
    this.savedMessage['report'] = true
    this.savedMessage['post_id'] = 0
    this.savedMessage['tags'] = `f6006a3ac4e9, ${this.contactForm.get('from_shopper').value}, ${this.contactForm.get('title').value}, ${this.contactForm.get('message').value}, ${this.contactForm.get('email').value}, ${this.savedMessage['selleremail']}, ${String(this.savedMessage['report'])}, ${String(this.savedMessage['post_id'])}`
    this.apiService.postMessage(this.savedMessage).subscribe(data => {
      this.submitted = 'submitted'
    })
  }

}
